import React from 'react';
import { MediaQueueTile } from '@cube3/ui/src/Prefabs/MediaQueue/MediaQueueTile';
import { Shimmer } from '@cube3/cubicle/src/core/atoms/Loader/Shimmer';

export const MediaQueueTileLoading = (props) => {
  const {
    thumb = <Shimmer height={5 * 8} />,
    title = 'Loading',
    status,
    statusLabel,
    contextRow = <Shimmer width={200} height={25} />,
    timestampRow = <Shimmer width={120} height={20} />,
    ...rest
  } = props;
  return (
    <MediaQueueTile
      thumb={thumb}
      contextRow={contextRow}
      title={title}
      timestampRow={timestampRow}
      status={status}
      statusLabel={statusLabel}
      {...rest}
    />
  );
};
